import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { TextField, type ITextFieldStyles } from "@fluentui/react/lib/TextField";
import { Text } from "@fluentui/react";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import { ltlFieldInputId } from "@taskpane/utils/ltlValidationFocus";
import { itemsEditorStyles as styles } from "./itemsEditor.styles";

type ItemRow = LTLState["items"][number];

interface Props {
  item: ItemRow;
  index: number;
  state: LTLState;
  onItemFieldChange: (index: number, field: keyof ItemRow, value: unknown) => void;
  onFieldBlur?: () => void;
  getTextFieldStyles: (fieldKey: string) => unknown;
}

export function LtlFreightItemLwhStack({
  item,
  index,
  state,
  onItemFieldChange,
  onFieldBlur,
  getTextFieldStyles,
}: Props): React.ReactElement {
  const st = (suffix: string) => getTextFieldStyles(`item${index}_${suffix}`) as ITextFieldStyles;

  return (
    <Box sx={styles.dimensionsGroup}>
      <Text styles={styles.dimensionsLabel}>Dimensions (in)</Text>
      <Stack direction="row" sx={styles.dimensionsRow}>
        <Box sx={styles.dimensionField}>
          <TextField
            label="L"
            type="number"
            value={item.length !== undefined && item.length !== null ? String(item.length) : ""}
            onChange={(e, newValue) =>
              onItemFieldChange(index, "length", newValue ? parseFloat(newValue) : undefined)
            }
            onBlur={onFieldBlur}
            id={ltlFieldInputId(`item${index}_length`)}
            styles={st("length")}
            errorMessage={state.errors[`item${index}_length`]}
          />
        </Box>
        <Text styles={styles.dimensionSeparator}>×</Text>
        <Box sx={styles.dimensionField}>
          <TextField
            label="W"
            type="number"
            value={item.width !== undefined && item.width !== null ? String(item.width) : ""}
            onChange={(e, newValue) =>
              onItemFieldChange(index, "width", newValue ? parseFloat(newValue) : undefined)
            }
            onBlur={onFieldBlur}
            id={ltlFieldInputId(`item${index}_width`)}
            styles={st("width")}
            errorMessage={state.errors[`item${index}_width`]}
          />
        </Box>
        <Text styles={styles.dimensionSeparator}>×</Text>
        <Box sx={styles.dimensionField}>
          <TextField
            label="H"
            type="number"
            value={item.height !== undefined && item.height !== null ? String(item.height) : ""}
            onChange={(e, newValue) =>
              onItemFieldChange(index, "height", newValue ? parseFloat(newValue) : undefined)
            }
            onBlur={onFieldBlur}
            id={ltlFieldInputId(`item${index}_height`)}
            styles={st("height")}
            errorMessage={state.errors[`item${index}_height`]}
          />
        </Box>
      </Stack>
    </Box>
  );
}
